export function isMac(): boolean {
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
}
